export default "__VITE_ASSET__ba6cd9da__"